import { object, string } from "yup";

import { Values } from "./send-email.types";

export const initialValues: Values = {
  email: "",
};

export const validationSchema = object().shape({
  email: string().email("Invalid Email").required("Email is required"),
});
